import './LoadError.scss';

function LoadError() {
  return (
    <div className="load-error">
      <div className="load-error__content">
        <h1>Something Went Wrong</h1>
        <p>We couldn't load this site right now. Please refresh the page or try again shortly.</p>
      </div>
    </div>
  );
}

export default LoadError;
